import { ThemeProvider } from "styled-components";
import { Dashboard } from "./Pages/Dashboard";
import { useAppSelector } from "./Hooks/Hooks";
import { selectActiveTheme } from "./Redux/Theme/ThemeSlice";

function App() {
    const theme = useAppSelector(selectActiveTheme);
    return (
        <ThemeProvider theme={theme}>
            <Dashboard />
        </ThemeProvider>
    );
}

export default App;
